<template>
  <section id="PROFILE_CONFIRMATION">
    <div class="container-fluid confirmation-content offset-top-3">
      <div class="container-fixed">
        <div class="button-bar">
          <VButton data-test="edit" class="btn-brand" :disabled="isBlocked" label="barring.btnNewProfile" @click="onOpenConfirmation" />
          <label for="info-button" class="offset-left-1">
            <template v-if="isBlocked">
              {{ $t('barring.profileBlocked') }}
            </template>
            <template v-else>
              {{ $t(`barring.newProfileText_${type}`) }}
            </template>
          </label>
          <button id="info-button" @click="onOpenModal">
            <span class="sr-only">{{ $t('barring.tooltipBtnDetails') }}</span>
            <img
              src="@/assets/images/barring/information_graphical.svg"
              width="30"
              height="30"
              alt=""
              aria-hidden="true"
              :title="$t('barring.tooltipBtnDetails')"
            />
          </button>
        </div>
        <VConfirmation
          v-if="isConfirmOpen"
          animation="slide"
          heading="barring.btnNewProfile"
          title="barring.tooltipNewProfile"
          class="offset-top-2"
          @abort="isConfirmOpen = false"
          @confirm="$emit('confirm')"
        >
          <template #prompt>
            <span v-html="$t(`barring.profileChangeConfirmText_${type}`)" />
          </template>
        </VConfirmation>
        <div v-if="isModalOpen" class="modal-backdrop">
          <VueGlobalEvents @keyup.esc="onCloseModal" />
          <VueFocusLock>
            <div class="modal-content">
              <button type="button" class="close" :title="$t('common.close')" @click="onCloseModal">
                <VSvgIcon name="cancel" variant="outlined" size="middle" />
                <span class="sr-only">{{ $t('common.close') }}</span>
              </button>
              <div>
                <div class="modal-header">
                  <h2 class="h4 modal-title" v-html="$t(`barring.profileChangeInfoTitle_${type}`)" />
                </div>
                <div class="modal-body">
                  <dl>
                    <p v-html="$t(`barring.profileChangeInfoText_${type}`)" />
                  </dl>
                </div>
              </div>
            </div>
          </VueFocusLock>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueFocusLock from 'vue-focus-lock';
import VueGlobalEvents from 'vue-global-events';
import VConfirmation from '@/components/Confirmation';
import VButton from '@/components/Button';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';

export default {
  name: 'BarringProfileConfirmation',

  components: {
    VSvgIcon,
    VueFocusLock,
    VueGlobalEvents,
    VConfirmation,
    VButton,
  },

  props: {
    type: {
      type: String,
      required: true,
    },

    isBlocked: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isModalOpen: false,
      isConfirmOpen: false,
      previousElement: document.activeElement,
    };
  },

  methods: {
    onOpenModal() {
      this.previousElement = document.activeElement;
      this.isModalOpen = true;
    },

    onCloseModal() {
      this.isModalOpen = false;
      this.$nextTick(() => {
        this.previousElement.focus();
      });
    },

    onOpenConfirmation() {
      this.isConfirmOpen = true;
    },
  },
};
</script>

<style scoped>
.button-bar {
  display: flex;
  align-items: center;
}

.confirmation-content {
  min-height: 132px;
}

#info-button {
  background: transparent;
  border: none;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content {
  width: 85%;
  max-width: 820px;
  margin: auto;
}

.badge {
  white-space: normal;
}

.badge button {
  margin-right: 6px;
  margin-left: 6px;
}
</style>
